import { render, staticRenderFns } from "./BaseIssue.vue?vue&type=template&id=3d19327c&scoped=true"
import script from "./BaseIssue.vue?vue&type=script&lang=js"
export * from "./BaseIssue.vue?vue&type=script&lang=js"
import style0 from "./BaseIssue.vue?vue&type=style&index=0&id=3d19327c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d19327c",
  null
  
)

export default component.exports